module.exports = __webpack_public_path__ + "static/img/装饰14.e34bf74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰14.svg
// module id = +qO+
// module chunks = 2